import {ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {SessionActions} from "../../../../shared/actions";
import {StockService} from "../../../services/stock.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Subject} from "rxjs/Subject";
import {AbstractListView} from "../../../../core/visbos-core/ui/components/abstract-list-view";
import {ProductBatch} from "../../../model/product-batch.type";
import {ApolloQueryObservable} from "apollo-angular";
import {FindProductBatchesQuery} from "../../../../shared/graphql/graphql.types";

@Component({
  selector: 'vb-search-product-batches',
  templateUrl: './search-product-batches.component.html',
  styleUrls: ['./search-product-batches.component.css']
})
export class SearchProductBatchesComponent extends AbstractListView implements OnInit {

  private batches$: ApolloQueryObservable<FindProductBatchesQuery>;
  batches: ProductBatch[];

  searchData: FormGroup;

  searchString: Subject<string> = new Subject<string>();

  @ViewChild('stocksTmpl')
  stocksTmpl: TemplateRef<any>;

  noStocksComparator: (valueA, valueB, rowA: ProductBatch, rowB: ProductBatch, sortDirection) => number =
    (valueA, valueB, rowA: ProductBatch, rowB: ProductBatch, sortDirection) => {

      if (!rowA.stocks || !rowA.stocks.length) {
        return -1;
      }

      if (!rowB.stocks || !rowB.stocks.length) {
        return 1;
      }

      if (rowA.stocks.length == rowB.stocks.length) {
        return 0;
      }

      if (rowA.stocks.length < rowB.stocks.length) {
        return -1;
      }

      if (rowA.stocks.length > rowB.stocks.length) {
        return 1;
      }

    };

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef, private fb: FormBuilder,
              private stockService: StockService) {
    super(sessionActions, cd);

    this.searchData = this.fb.group({
      searchString: [null, Validators.required]
    });

  }


  ngOnInit(): void {
    super.ngOnInit();

    //TODO: Show deleted, rteformat stocks, show depots and yards and admin units
    this.columns = [
      {prop: 'batch_number', name: 'Chargennummer'},
      {prop: 'use_before_date_formatted', name: 'MHD'},
      {name: 'Anzahl Bestände', cellTemplate: this.stocksTmpl, comparator: this.noStocksComparator}
    ];

    this.addComponentData(this.batches$ = this.stockService.findProductBatches(this.searchString, null, true, null));
    this.addSubscription(this.batches$.subscribe(res => {
      this.batches = res.data.findProductBatches;
      this.rows = this.batches;
    }))
  }

  onStartSearchClicked() {
    this.searchString.next(this.searchData.get('searchString').value);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/components/search-product-batches/search-product-batches.component.ts